export const selectAllItems = (payload) =>
	payload.map((database) => ({
		id: parseInt(database.id, 10),
		data: database.data,
	}))
